import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * カギのトラブル
 */
const LossKeyIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g transform="translate(-12 -477)">
          <rect
            width="40"
            height="40"
            rx="6"
            transform="translate(12 477)"
            fill={CLIENT_SETTINGS.colors.background}
          />
          <path
            d="M207.689,126.092a3.859,3.859,0,0,0-1.22-3.785,25.168,25.168,0,0,0-8.519-4.918,3.859,3.859,0,0,0-3.888.836,23.958,23.958,0,0,0-6.4,9.224,3.859,3.859,0,0,0,.979,4.143q.75.7,1.544,1.343l-6.721,11.64a1.478,1.478,0,0,0,.539,2.013l4.152,2.4a1.478,1.478,0,0,0,2.013-.539l6.721-11.64q.949.368,1.935.666a3.859,3.859,0,0,0,4.078-1.223A23.958,23.958,0,0,0,207.689,126.092Zm-18.943,21.07-1.189-.686,4.434-7.679-1.082-.624-4.434,7.679-1.189-.686,6.41-11.1q.828.571,1.689,1.069t1.771.928Zm14.839-21.141-7.409-4.277a.937.937,0,0,1,.937-1.622l7.409,4.278a.937.937,0,0,1-.937,1.622Z"
            transform="translate(-163.268 363.819)"
            fill={CLIENT_SETTINGS.colors.main}
          />
        </g>
      </svg>
    </Icon>
  )
}

export default LossKeyIcon
